export default import.meta.ROLLUP_FILE_URL_gV0JVhvBDfrQsRvHxCau5Q;